import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSButton from "../../../Components/Button/WSButton";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const Company: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const id = params?.id;

  const { showMessage } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    updateMainHeader("Company");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Company List": "/company/list" },
    { [!id ? "Add Company" : "Update Company"]: "/company/create" },
  ]);

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const response = await callAPI(
            `Vyapar/Company/${id}`,
            Method.GET
          );
          console.log('fetchData response===>', response);
          if (response && response.data) {
            const companyData = response.data;
            setValue("name", companyData.companyName);
          }
        } catch (error) {
          console.error("Failed to fetch company data:", error);
        }
      };
      fetchData();
    }
  }, [id, setValue]);

  const handleCancelClick = () => {
    navigate("/company/list");
  };

  const handleData = async (data: any) => {
    try {
      setLoading(true);

      const request = {
        CategoryName: data.name,
      };

      let response;

      if (id) {
        response = await callAPI(
          `Vyapar/Company/${id}`,
          Method.PUT,
          request
        );
      } else {
        response = await callAPI(
          "Vyapar/Company",
          Method.POST,
          request
        );
      }

      console.log('handleData response===>', response);
      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );

        if (response.success === true) {
          navigate("/company/list");
        }
      }
    } catch (error) {
      console.error("Failed to save user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDataSaveAndNew = async (data: any) => {
    try {
      setLoadingSaveAndNew(true);

      const request = {
        CategoryName: data.name,
      };

      let response;

      if (id) {
        response = await callAPI(
          `Vyapar/Company/${id}`,
          Method.PUT,
          request
        );
      } else {
        response = await callAPI(
          "Vyapar/Company",
          Method.POST,
          request
        );
      }

      console.log('handleDataSaveAndNew response===>', response);

      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );

        if (response.success === true) {
          reset();
        }
      }
    } catch (error) {
      console.error("Failed to save user:", error);
    } finally {
      setLoadingSaveAndNew(false);
    }
  };

  return (
    <>
      <Grid p={3}>
        <form onSubmit={handleSubmit(handleData)}>
          <Grid
            sx={{
              padding: 4,
              backgroundColor: "#fff",
              borderRadius: 2,
              border: "1px solid lightgrey",
              marginTop: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <WSTextField
                  label={"Company Name"}
                  {...register("name")}
                  id="name"
                  name="name"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
            <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>
            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save & New"
                size="medium"
                variant="outlined"
                color="primary"
                onClick={handleSubmit(handleDataSaveAndNew)}
                loading={loadingSaveAndNew}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>

            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save"
                size="medium"
                variant="outlined"
                color="primary"
                loading={loading}
                onClick={handleSubmit(handleData)}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
});
